import "./App.css";
import { BrowserRouter } from "react-router-dom";
import AppRoutes from "./routes/AppRoutes";
import { ToastContainer } from "react-toastify";
import 'react-toastify/dist/ReactToastify.css';
import SessionInterceptor from './components/SessionInterceptor';

function App() {
  return (
      <BrowserRouter>
      <SessionInterceptor />
      <AppRoutes></AppRoutes>
      <ToastContainer position="top-right" autoClose={5000} />
    </BrowserRouter>
  );
}
export default App;
